export default __webpack_public_path__ + "static/img-everest-ventures-group-d65513e6008af5f838f217425630c503.png";